import { Mail, Copy, Check } from "lucide-react";
import { useState } from "react";
import { SiYoutube, SiInstagram, SiTiktok } from "react-icons/si";
import { SITE } from "@/data/site";

const socials = [
  { key: "youtube", href: SITE.socials.youtube, Icon: SiYoutube, label: "YouTube" },
  { key: "instagram", href: SITE.socials.instagram, Icon: SiInstagram, label: "Instagram" },
  { key: "tiktok", href: SITE.socials.tiktok, Icon: SiTiktok, label: "TikTok" },
];

export default function Contact({ embedded = false }) {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(SITE.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <div data-testid="contact-page" className={embedded ? "" : "pt-16"}>
      <section className="bg-cream flex items-center py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6 md:px-8 text-center w-full">
          <p className="text-teal text-xs tracking-[0.25em] uppercase font-semibold mb-6">
            Contact
          </p>

          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-tighter text-ink leading-none">
            Contact for availability
            <br />
            and enquiries.
          </h1>

          <div className="mt-12 flex flex-col items-center gap-6">
            <a
              href={`mailto:${SITE.email}`}
              data-testid="contact-email-link"
              className="group inline-flex items-center gap-3 font-display text-2xl sm:text-4xl md:text-5xl text-ink border-b-2 border-ink/20 hover:border-ink pb-2 transition-colors duration-300"
            >
              <Mail className="text-steel" size={32} strokeWidth={1.5} />
              {SITE.email}
            </a>

            <button
              onClick={copyEmail}
              data-testid="contact-copy-btn"
              className="inline-flex items-center gap-2 rounded-full bg-terracotta text-ink font-medium px-6 py-3 text-sm transition-all duration-300 hover:bg-ink hover:text-cream"
            >
              {copied ? <Check size={16} /> : <Copy size={16} />}
              {copied ? "Copied!" : "Copy email"}
            </button>
          </div>

          <div className="mt-16">
            <div className="flex justify-center gap-4">
              {socials.map(({ key, href, Icon, label }) => (
                <a
                  key={key}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`contact-social-${key}`}
                  className="h-14 w-14 rounded-full bg-ink text-cream flex items-center justify-center transition-all duration-300 hover:bg-steel hover:scale-105"
                >
                  <Icon size={22} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
